module.exports = __webpack_public_path__ + "static/media/diaadia-1.003b350b.jpg";